import { useState } from "react";
import { Container, Col, Row } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import { BreadcrumbItem } from "reactstrap";
import { useHistory } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as OrganizationQL from "queries/organization";
import { CancellableContent } from "@repoflow/components/content-cancel";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>New</BreadcrumbItem>;


export const Content = ({
  match: {
    params,
    params: { domain },
  },
}) => {
  const [phase, setPhase] = useState("init");
  const history = useHistory();
  // The domain view. replace(), not goBack(): every other create form in this
  // app lands somewhere fixed, whereas goBack() depended on how you arrived.
  const {
    parent: { base },
  } = useSectionContext();

  const initial = {
    description: "",
  };
  return (
    <Mutation
      initial={initial}
      context={{ phase }}
      target={{ $ref: "/Public/Organization/Create" }}
      mutation={OrganizationQL.create}
      update={OrganizationQL.update(params)}
      onMutate={({ state: { values }, handler }) => {
        setPhase("loading");

        handler({
          variables: {
            domain,
            input: values,
          },
        });
      }}
      onCompleted={() => {
        setPhase("complete");
        history.replace(base);
      }}
      onError={(error) => {
        // Without this the Create button keeps spinning, disabled, forever.
        setPhase("init");
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({
  schema,
  state,
  mutate,
  context: {
    phase,
  },
  target,
}) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    onSubmit: () => {
      mutate();
    },
    onChange: (vals) => {
      setValues(vals);
    },
    config: {
      "/Public/Organization/Create": {
        fields: [
          {
            property: "description",
            textarea: true,
          },
        ],
      },
    },
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit" loading={phase === "loading"}>
                Create
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
